/*
 * @Author: wp
 * @Date: 2022-12-30 15:03:21
 * @Descripttion:
 */

export const strict = false
export const state = () => ({
	config: {}, // 配置
	// ossToken: null, // ossToken
	hideFooter: true, // 公共组件状态
	hideHeader: true, // 公共组件状态
	pzfrom: null, // 第三方信息
	bd_vid: null, // 第三方信息
	qhclickid: null, // 第三方信息
    sourceid:null,//360信息
	markId: null, //微博信息
	afterGoods: {}, // 售后商品信息存储
	after: {}, // 售后提交存的东西暂时不晓得啥玩意
	uctrackid: null, // 第三方信息
	keyword: null, // 第三方信息
	operatingSystem: null, // 操作系统信息获取
	myGoodsPage: {}, // 商品列表分页存储
	bargainingState: false, // 一键砍价状态
	editGoodsState: false, // 商品编辑状态
	messageReceiptState: true, // 当前窗口消息回执状态
	severTime: null,
	clientIp: '',
    wbxdId: null, // 微博小店邀请码
})
export const mutations = {
	SET_PUBLIC_CONFIG: (state, config) => {
		state.config = config
	},
	SET_OSS_TOKEN: (state, oss) => {
		state.ossToken = oss
	},
	SET_HIDE: (state, flag) => {
		state.hideFooter = flag
		state.hideHeader = flag
	},
	SET_PZ_FROM: (state, form) => {
		state.pzfrom = form
	},
	SET_URL_PARAM: (state, form) => {
		state.urlParam = form
	},
	SET_DB_VID: (state, form) => {
		state.bd_vid = form
	},
	SET_QH_CLICK_ID: (state, form) => {
		state.qhclickid = form
	},
    SET_SOURCE_ID: (state, form) => {
        state.sourceid = form
    },
	SET_AFTER_GOODS: (state, data) => {
		state.afterGoods = data
	},
	SET_AFTER: (state, data) => {
		state.after = data
	},
	SET_UCTRACKID: (state, data) => {
		state.uctrackid = data
	},
	SET_SEARCH_WORD: (state, data) => {
		state.keyword = data
	},
	SET_OPERATING_SYSTEM: (state, data) => {
		state.operatingSystem = data
	},
	SET_MY_GOODS_PAGE: (state, data) => {
		state.myGoodsPage = data
	},
	SET_BARGAINING_STATE: (state, data) => {
		state.bargainingState = data
	},
	SET_EDITGOODS_STATE: (state, data) => {
		state.editGoodsState = data
	},
	SET_MESSAGE_RECEIPT_STATE: (state, data) => {
		state.messageReceiptState = data
	},
	SET_SEVER_TIME: (state, data) => {
		state.severTime = data
	},
	SET_CLIENT_IP(state, ip) {
		state.clientIp = ip
	},
	SET_MARK_ID: (state, form) => {
		state.markId = form
	},
    SET_WBXD_ID: (state, form) => {
		state.wbxdId = form
	}
}

export const actions = {
	AppPublicConfig({ commit }) {
		return new Promise((resolve, reject) => {
			this.$api
				.publicConfig()
				.then(response => {
					const data = response.data
					console.log(data);

					if (!data.length) return
					const configObj = data.reduce((obj, cur, index) => {
						obj[`config_${cur.id}`] = cur.content
						return obj
					}, {})
					
					commit('SET_PUBLIC_CONFIG', configObj)
					resolve(configObj)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	AppPublicHidePage({ commit }, flag) {
		commit('SET_HIDE', flag)
	},
	AppOssAuth({ commit }, token) {
		if (!token) {
			commit('SET_OSS_TOKEN', null)
			return
		}
		const obj = {
			accessKeyId: token.accessKeyId,
			accessKeySecret: token.accessKeySecret,
			bucket: token.bucketName,
			region: token.regionId,
			endpoint: token.endpoint,
			stsToken: token.securityToken
		}
		commit('SET_OSS_TOKEN', obj)
	},
	AppGetOssAuth({ commit }) {
		return new Promise((resolve, reject) => {
			this.$api
				.stsAuth()
				.then(response => {
					if (response.code == 'SUCCESS') {
						const token = response.data
						const obj = {
							accessKeyId: token.accessKeyId,
							accessKeySecret: token.accessKeySecret,
							bucket: token.bucketName,
							region: token.regionId,
							endpoint: token.endpoint,
							stsToken: token.securityToken
						}
						commit('SET_OSS_TOKEN', obj)
					}
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	GetSeverTime({ commit }) {
		return new Promise((resolve, reject) => {
			this.$api
				.serverTime()
				.then(res => {
					let severTime = res.data - Date.now()
					commit('SET_SEVER_TIME', severTime)
					resolve(severTime)
				})
				.catch(error => {
					reject(error)
				})
		})
	}
}
export const getters = {
	clientIp: state => state.clientIp,
	config: state => state.config,
	// ossToken: (state) => state.ossToken,
	hideFooter: state => state.hideFooter,
	hideHeader: state => state.hideHeader,
	pzfrom: state => state.pzfrom,
	bd_vid: state => state.bd_vid,
	qhclickid: state => state.qhclickid,
    sourceid: state => state.sourceid,
	markId: state => state.markId,
	afterGoods: state => state.afterGoods,
	after: state => state.after,
	uctrackid: state => state.uctrackid,
	keyword: state => state.keyword,
	operatingSystem: state => state.operatingSystem,
	myGoodsPage: state => state.myGoodsPage,
	bargainingState: state => state.bargainingState,
	editGoodsState: state => state.editGoodsState,
	messageReceiptState: state => state.messageReceiptState,
	severTime: state => state.severTime,
    wbxdId: state => state.wbxdId,
}
